<template>
  <div id="app">
    <component :is="$layout + '-layout'">
      <transition
        v-if="$auth.ready()"
        name="fade-transform"
        mode="out-in"
      >
        <router-view :key="$route.path" />
      </transition>
    </component>
  </div>
</template>

<script>
export default {

}
</script>